import { configureGraphQLClient } from '#plugins/graphql.ts'

import type { App } from 'vue'

export function initGraphql(app: App) {
  configureGraphQLClient(app)
}
